<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">契合科技数据分析平台</div>
                            <div class="title">
                                驱动业务转化的营销数据分析平台
                            </div>
                            <p class="sub-title">
                                数据驱动营销业务的分析与决策，结合精准营销的行动与反馈，实现数字化营销，打通营销闭环
                            </p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt100">
                <div class="dom-item">
                    <div class="dom-content mt60 flex">
                        <div class="mb-box">
                            <div class="mb">
                                <div class="mb-title">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_1.png"
                                        class="icon"
                                    /><span class="mb-title-txt">数据看板</span>
                                </div>
                                <div class="mb-desc">
                                    基于数仓的数据进行数据可视化展示，支持预置看板和自定义看板内容的展示，支持多维度下数据展示
                                </div>
                            </div>
                            <div class="mb">
                                <div class="mb-title">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_2.png"
                                        class="icon"
                                    /><span class="mb-title-txt">数据分析</span>
                                </div>
                                <div class="mb-desc">
                                    可根据指标和维度进行数据的筛选分析，查看关注的指标数据情况，数据可保存至数据看板中进行长期监测
                                </div>
                            </div>
                            <div class="mb">
                                <div class="mb-title">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_3.png"
                                        class="icon"
                                    /><span class="mb-title-txt">用户画像</span>
                                </div>
                                <div class="mb-desc">
                                    根据业务数据对用户进行动态及静态打标签，并统一维护用户标签，用户标签类型包含多种形式
                                </div>
                            </div>
                            <div class="mb">
                                <div class="mb-title">
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_4.png"
                                        class="icon"
                                    /><span class="mb-title-txt">预警管理</span>
                                </div>
                                <div class="mb-desc">
                                    统一维护所有预警数据，进行活动分析时，可以对某些关键指标进行预警设置。通过多种方式及时通知接收人进行处理
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt163">
                <div class="dom-item">
                    <div class="dom-title">数据能力打通营销最后的闭环</div>
                    <div class="imgbox">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/img1.png"
                            class="img"
                        /><span class="txt t1">营销活动发布</span
                        ><span class="txt t2">数据能力打通营销闭环</span
                        ><span class="txt t3">策略优化</span
                        ><span class="txt t4">活动数据采集</span
                        ><span class="txt t5">营销自动化流程</span
                        ><span class="txt t6">ETL处理</span
                        ><span class="txt t7">数据可视化及分析</span>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt100 dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">底层数据能力支撑</div>
                    <div class="lb-box">
                        <div class="lb">
                            <div class="lb-title">数据接入</div>
                            <div class="lb-txt">
                                支持各种来源、各种类型数据的实时和离线接入，通过数据接入将这些零散的数据进行整合，完成从数据采集、数据传输、数据处理、数据缓存到统一的数据平台。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_5.png"
                            />
                        </div>
                        <div class="lb">
                            <div class="lb-title">数据仓库</div>
                            <div class="lb-txt">
                                构建面向分析的集成化数据环境，为企业提供决策支持。源数据通过ETL的日常任务调度导出，并经过转换后以特定的形式存入数据仓库。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_6.png"
                            />
                        </div>
                        <div class="lb">
                            <div class="lb-title">API服务</div>
                            <div class="lb-txt">
                                对特定的数据要求提供 API
                                服务，为业务/三方提供数据支持最大程度的扩展数据能力，扩充支持数据服务边界，根据需求可以进行
                                API 定制，为企业提供最大价值。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_7.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt120">
                <div class="dom-item">
                    <div class="dom-title">为业务产品赋能</div>
                    <div class="nb-box mt80">
                        <div class="nb">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_8.png"
                            />
                            <div class="nb-title">数据管理</div>
                            <div class="nb-txt">
                                对接入数据进行统一的可视化管理，包括埋点数据、三方数据等，直观的了解目前数据的范围情况并进行可视化的维护管理。
                            </div>
                        </div>
                        <div class="nb">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_9.png"
                            />
                            <div class="nb-title">指标管理</div>
                            <div class="nb-txt">
                                支持预置指标及自定义指标的管理，可以自行创建指标，通过对元数据中的数据进行组合运算形成指标，保存后在指标列表中进行展示及维护
                                。
                            </div>
                        </div>
                        <div class="nb">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_10.png"
                            />
                            <div class="nb-title">维度管理</div>
                            <div class="nb-txt">
                                根据数仓内的数据进行维度抽离，包括城市、性别、手机系统、交易类型等、对维度进行展示管理，根据业务需求进行维护更新。
                            </div>
                        </div>
                        <div class="nb">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/datacrm/icon_11.png"
                            />
                            <div class="nb-title">营销自动化</div>
                            <div class="nb-txt">
                                打通业务产品壁垒，通过数据能力，实现自动化营销能力，利用数据能力，实现营销闭环进而为业务提供更多支持。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt120">
                <div class="dom-item">
                    <div class="dom-title">数据安全与隐私</div>
                    <div class="kb-box mt80">
                        <div class="kb">
                            <div class="kb-title">加密传输</div>
                            <div class="kb-txt">
                                对传输中的数据流进行加密处理，防止泄露、篡改等问题的发生
                            </div>
                        </div>
                        <div class="kb-line"></div>
                        <div class="kb">
                            <div class="kb-title">环境隔离与权限控制</div>
                            <div class="kb-txt">
                                服务器物理隔离同时加以权限的控制 保证数据的安全
                            </div>
                        </div>
                        <div class="kb-line"></div>
                        <div class="kb">
                            <div class="kb-title">数据脱敏</div>
                            <div class="kb-txt">
                                对某些敏感信息通过脱敏规则进行数据的变形，实现敏感隐私数据的可靠保护
                            </div>
                        </div>
                        <div class="kb-line"></div>
                        <div class="kb">
                            <div class="kb-title">数据加密</div>
                            <div class="kb-txt">
                                利用密码技术对信息进行加密，实现信息隐蔽，从而起到保护信息的安全的作用
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <more :moreid="id"></more>
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            id: 6
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
         denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-datacrm.css";
</style>


// WEBPACK FOOTER //
// src/views/slg/datacrm.vue